import React from 'react';
import { Button, Card, notification } from 'antd';
import { useEffect, useState } from 'react';
import { deleteDiscount, getAllDiscount, postDiscount, updateDiscount } from 'utils/apis/configDiscount';
import TableComponent from './table/Table';
import { MainContainer } from './DiscountConfig.styles';
import DiscountModal from './DiscountModal/DiscountModal';
import { getHostsWithoutParentAndSeperatedBilling } from 'utils/apis/host';

const DiscountConfig = () => {
  const [isVisible, setVisible] = useState(false);
  const [discountData, setDiscountData] = useState([]);
  const [hostData, setHostData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDiscount, setSelectedDiscount] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await getAllDiscount();
      setDiscountData(response.data);

      const host = await getHostsWithoutParentAndSeperatedBilling();
      setHostData(host.data);
      console.log(response.data);
    } catch (error) {
      console.error('Error fetching discount data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectedDiscount = discount => {
    setSelectedDiscount(discount);
    setVisible(true);
  };

  const showModal = () => {
    setVisible(true);
  };
  const closeModal = () => {
    setVisible(false);
  };

  const handleSubmit = async (values, selectedDiscountId) => {
    try {
      if (selectedDiscountId === 'new') {
        await postDiscount(values);
        notification.success({
          message: 'Success',
          description: 'Discount has been created successfully.'
        });
      } else {
        await updateDiscount(selectedDiscountId, values);
        notification.success({
          message: 'Success',
          description: 'Discount has been updated successfully.'
        });
      }
      setSelectedDiscount('');
      fetchData();
    } catch (error) {
      console.error('Error submitting discount:', error);
    }
  };
  const handleDelete = async selectedDiscountId => {
    try {
      const deleted = await deleteDiscount(selectedDiscountId);
      notification.success({
        message: 'Deleted',
        description: 'Discount has been deleted successfully.'
      });
      console.log('Discount deleted successfully:', deleted);
      fetchData();
    } catch (error) {
      console.error('Error deleting discount:', error);
      notification.success({
        message: 'Deleted',
        description: `Encoutered Problem ${error}`
      });
    }
  };

  return (
    <MainContainer>
      <Button onClick={showModal} style={{ marginBottom: '40px' }} type="primary">
        Create Discount
      </Button>
      <Card>
        <TableComponent data={discountData} loading={isLoading} onSelectedDiscount={handleSelectedDiscount} />
      </Card>
      <DiscountModal
        offVisible={closeModal}
        visibility={isVisible}
        fetchData={fetchData}
        hostData={hostData}
        selectedDiscount={selectedDiscount}
        onSubmit={handleSubmit}
        resetSelectedDiscount={() => setSelectedDiscount('')}
        onDelete={handleDelete}
      />
    </MainContainer>
  );
};

export default DiscountConfig;
